import React from 'react';
import PropTypes from 'prop-types';
import styles from './Stopover.module.scss';
import Leg from "./Leg/Leg";
import {connect} from "react-redux";
import {
    selectStopoverIncomingAirport,
    selectStopoverOutgoingAirport,
    setIncomingNumberOfNights,
    setOutgoingNumberOfNights,
} from "../../../../services/flightCourse/actions";
import StopoverRefreshing from "./StopoverRefreshing/StopoverRefreshing";
import ResponsiveImage from "./ResponsiveImage/ResponsiveImage";
import stopoverImage from '../../../../assets/media/stopoverImage.svg';
import {withTranslation} from "react-i18next";
import IconButton from "../../../Common/IconButton/IconButton";

const Stopover = ({
                      expanded, origin, destination, outgoing, incoming, checkOutgoingAvailability, checkIncomingAvailability,
                      setOutgoing, setIncoming, isRoundTrip, t, ...props
                  }) => {

    const hideOutbound = outgoing.disabledAirports.length >= 2;
    const hideInbound = incoming.disabledAirports.length >= 2 || !isRoundTrip;
    const bothLegsHidden = Boolean(hideOutbound && hideInbound);

    if (!expanded || bothLegsHidden) {
        return null;
    }

    const image = <img alt={'stopover'} src={stopoverImage} width={'100%'}/>;

    const legContainerClasses = [styles.stopoverLegContainer];
    if (hideOutbound || hideInbound) legContainerClasses.push(styles.stopoverLegContainerOnlyOneLegVisible);

    return (
        <div className={styles.container}>
            <StopoverRefreshing/>
            <div className={styles.introTextContainer}>
                {t('Add a stopover up to 7 days in the Azores to your Atlantic journey and discover the unique beauty of one of the most sustainable destinations in the world. On the way out, on the way back, on both. Your choice.')}
                &nbsp;<IconButton containerOverrideClasses={[styles.introInfoButton]} clickHandler={() => window.open('/stopover')}/>
            </div>
            <br/>
            <div className={styles.stopoverImage}>
                <ResponsiveImage
                    images={{
                        md: image
                    }}
                />
                {t('Stopover in the Azores')}
            </div>
            <br/>
            <div className={styles.stopoverForm}>
                {!hideOutbound && (
                    <div className={legContainerClasses.join(' ')}>
                        <Leg originLabel={origin && origin.code}
                             destinationLabel={destination && destination.code}
                             departureDateLabel={outgoing.departureDate}
                             selectedAirport={outgoing.selectedAirport}
                             disabledAirports={outgoing.disabledAirports}
                             disabledNights={outgoing.selectedAirport ? outgoing.disabledNights[outgoing.selectedAirport.toUpperCase()] : []}
                             onSelect={checkOutgoingAvailability}
                             onNightSelect={nights => setOutgoing(nights)}
                             selectedNight={outgoing.numberOfNights}
                             message={outgoing.message}
                             hide={hideOutbound}
                             icon={<i className={`icon-sata-icon-aviao-partida`}
                                      style={{fontSize: '1.2em', color: '#2d80b9'}}/>}
                        />
                    </div>
                )}
                {!hideInbound && (
                    <div className={legContainerClasses.join(' ')}>
                        <Leg originLabel={destination.code}
                             destinationLabel={origin.code}
                             departureDateLabel={incoming.departureDate}
                             selectedAirport={incoming.selectedAirport}
                             disabledAirports={incoming.disabledAirports}
                             disabledNights={incoming.selectedAirport ? incoming.disabledNights[incoming.selectedAirport.toUpperCase()] : []}
                             onSelect={checkIncomingAvailability}
                             onNightSelect={nights => setIncoming(nights)}
                             selectedNight={incoming.numberOfNights}
                             message={incoming.message}
                             hide={hideInbound}
                             icon={<i className={`icon-sata-icon-aviao-regresso`}
                                      style={{fontSize: '1.2em', color: '#2d80b9'}}/>}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

const STOPOVER_LEG_SHAPE = PropTypes.shape({
    selectedAirport: PropTypes.string,
    numberOfNights: PropTypes.number,
    disabledAirports: PropTypes.array,
    disabledNights: PropTypes.shape({PDL: PropTypes.array, TER: PropTypes.array}),
    departureDate: PropTypes.any,
})

Stopover.propTypes = {
    expanded: PropTypes.bool,
    isRoundTrip: PropTypes.bool,
    origin: PropTypes.object,
    destination: PropTypes.object,
    outgoing: STOPOVER_LEG_SHAPE,
    incoming: STOPOVER_LEG_SHAPE,
    checkOutgoingAvailability: PropTypes.func,
    checkIncomingAvailability: PropTypes.func,
    setOutgoing: PropTypes.func,
    setIncoming: PropTypes.func,
    t: PropTypes.func,
};

Stopover.defaultProps = {
    expanded: true,
    isRoundTrip: true,
    origin: null,
    destination: null,
    outgoing: null,
    incoming: null,
    checkOutgoingAvailability: () => null,
    checkIncomingAvailability: () => null,
    setOutgoing: () => null,
    setIncoming: () => null,
    t: s => s,
};

export {Stopover};

export default connect(state => ({
    origin: state.flightCourse.legs[0].origin,
    destination: state.flightCourse.legs[0].destination,
    isRoundTrip: state.flightCourse.roundTrip === 'RETURN',
    outgoing: state.flightCourse.stopover.outgoing,
    incoming: state.flightCourse.stopover.incoming,
    expanded: state.flightCourse.stopover.eligible,
}), {
    checkOutgoingAvailability: selectStopoverOutgoingAirport,
    checkIncomingAvailability: selectStopoverIncomingAirport,
    setOutgoing: setOutgoingNumberOfNights,
    setIncoming: setIncomingNumberOfNights,
})(withTranslation()(Stopover));
